import CheckNewOrders from "../symbols/checkNewCollectOrders";
import { HttpRequestPost } from "../../service";

const checkNewCollectOrdersAction = () => ({
  type: CheckNewOrders.CHECK_NEW_COLLECT_ORDERS,
});
const checkNewCollectOrdersSuccessAction = (data: any) => ({
  type: CheckNewOrders.CHECK_NEW_COLLECT_ORDERS_SUCCESS,
  payload: data,
});
const checkNewCollectOrdersFailureAction = (data: any) => ({
  type: CheckNewOrders.CHECK_NEW_COLLECT_ORDERS_FAILURE,
  payload: data,
});
const checkNewOrdersPendingRefreshTimeStampAction = () => ({
  type: CheckNewOrders.CHECK_NEW_COLLECT_ORDERS_REFRESH_TIME_STAMP,
});
const clearCheckNewOrdersPendingAction = () => ({
  type: CheckNewOrders.CHECK_NEW_COLLECT_ORDERS_PENDING,
});
export function getCheckNewCollectOrder(
  Tab: string = "Open",
  Date: string,
  callback?: (resp?: any) => void
) {
  return (dispatch: any) => {
    dispatch(checkNewCollectOrdersAction());
    HttpRequestPost(
      `/collect/check-new/${Tab}`,
      dispatch,
      checkNewCollectOrdersSuccessAction,
      checkNewCollectOrdersFailureAction,
      true,
      { Date },
      callback
    );
  };
}

export function clearCheckNewCollectOrders() {
  return (dispatch: any) => {
    dispatch(clearCheckNewOrdersPendingAction());
  };
}
export function refreshTimeStampForCheckNewCollectOrder() {
  return (dispatch: any) => {
    dispatch(checkNewOrdersPendingRefreshTimeStampAction());
  };
}
